module.exports = __webpack_public_path__ + "img/error.01f17687.jpg";